import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-3050">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3051">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-3052" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-3053">
        <div className="max-w-3xl mx-auto text-center" data-id="element-3054">
          <div className="flex justify-center mb-5" data-id="element-3055">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3056">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-3057" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-3058">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-3059">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-3060">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3061" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-3062">
        {/* IMPORTANT WARNING */}
        <section data-id="element-3063">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-3064">
            <div className="flex items-start gap-4" data-id="element-3065">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-3066">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-3067" />
              </div>
              <div data-id="element-3068">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-3069">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-3070">
                  Estás A <span className="font-black text-white" data-id="element-3071">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-3072">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-3073">
          <div className="text-center mb-8" data-id="element-3074">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3075">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3076" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3077">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-3078">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3079">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3080">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3081" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3082">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-3083">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3084">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3085">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3086" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3087">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-3088">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3089">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3090">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3091" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3092">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-3093">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3094">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3095">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3096" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3097">
                <span className="font-bold text-white" data-id="element-3098">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-3099">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3100">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3101" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3102">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-3103">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-3104">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-3105">
            <div className="flex items-center gap-3 mb-8" data-id="element-3106">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-3107">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3108" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-3109">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-3110">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-3111">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-3112">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3113">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-3114" />
                </div>
                <div data-id="element-3115">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3116">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3117">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-3118">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3119">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-3120" />
                </div>
                <div data-id="element-3121">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3122">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3123">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-3124">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3125">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-3126" />
                </div>
                <div data-id="element-3127">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3128">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3129">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-3130">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3131">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-3132" />
                </div>
                <div data-id="element-3133">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3134">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3135">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-3136">
          <div className="text-center mb-8" data-id="element-3137">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3138">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3139" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3140">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-3141">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3142">
              <div className="flex gap-1 mb-4" data-id="element-3143">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3144" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3145" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3146" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3147" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3148" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3149" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3150">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3151">
                <p className="font-bold text-white text-sm" data-id="element-3152">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-3153">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3154">
              <div className="flex gap-1 mb-4" data-id="element-3155">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3156" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3157" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3158" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3159" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3160" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3161" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3162">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3163">
                <p className="font-bold text-white text-sm" data-id="element-3164">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-3165">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3166">
              <div className="flex gap-1 mb-4" data-id="element-3167">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3168" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3169" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3170" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3171" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3172" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3173" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3174">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3175">
                <p className="font-bold text-white text-sm" data-id="element-3176">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-3177">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-3178">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-3179">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3180" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-3181">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-3182" />
      <WhatsAppButton data-id="element-3183" />
    </div>;
}